/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum KeepRuleType {
  TYPE_INVALID = 0,
  ELEMENT = 1,
  URL = 2,
  DWELL = 3,
  CRASH = 4,
}
